import { startOfDay } from "date-fns";

export const today = startOfDay(new Date()).toISOString();
